export const usTerritoriesPVQOptions = [
  { name: 'American Samoa', postalCode: 'AS' },
  { name: 'Guam', postalCode: 'GU' },
  { name: 'Marshall Islands', postalCode: 'MH' },
  { name: 'Micronesia', postalCode: 'FM' },
  { name: 'Northern Mariana Islands', postalCode: 'MP' },
  { name: 'Palau', postalCode: 'PW' },
  { name: 'Puerto Rico', postalCode: 'PR' },
  { name: 'Virgin Islands', postalCode: 'VI' },
];

export const usTerritoriesPVQValues = usTerritoriesPVQOptions.map((i) => i.postalCode);

export const usTerritoriesSFOptions = [
  ...usTerritoriesPVQOptions,
  { name: 'Baker Island', postalCode: 'FQ' },
  { name: 'Howland Island', postalCode: 'HQ' },
  { name: 'Jarvis Island', postalCode: 'DQ' },
  { name: 'Johnston Atoll', postalCode: 'JQ' },
  { name: 'Kingman Reef', postalCode: 'KQ' },
  { name: 'Midway Atoll', postalCode: 'MQ' },
  { name: 'Navassa Island', postalCode: 'BQ' },
  { name: 'Palmyra Atoll', postalCode: 'LQ' },
  { name: 'Wake Island', postalCode: 'WQ' },
];

// Just an array of the postalCodes
export const usTerritoriesSFValues = usTerritoriesSFOptions.sort((a, b) => a.postalCode.localeCompare(b.postalCode)).map((i) => i.postalCode);
